import { IPlaceAddress } from './types';

export const parseLocationPrediction = (address: IPlaceAddress | null) => {
  if (!address) {
    return '';
  }

  return `${address?.addressLine1 ?? ''} ${address?.city ?? ''}`.trim();
};
